<div class="seds-header-user">
  <button
    class="button-menu"
    tabindex="0"
    [class]="colorMode"
    [matMenuTriggerFor]="menu"
    [attr.aria-label]="userData?.name">
    <div tabindex="0" class="seds-flex seds-flex-row seds-items-center">
      <p tabindex="0" class="seds-text-end seds-px-2 seds-py-2 seds-caption">
        <small>Olá</small><br />
        <strong>
          {{ userData?.name }}
        </strong>
      </p>
      <seds-avatar
        tabindex="0"
        *ngIf="userData?.showAvatar"
        [colorMode]="'default-dark'"
        [size]="'large'"
        [text]="name"
        [avatarImage]="userData?.avatarImage"></seds-avatar>
      <mat-icon tabindex="0">expand_more</mat-icon>
    </div>
  </button>
</div>
<mat-menu #menu="matMenu" xPosition="before" class="user-header-menu">
  <div class="header-user-menu-content" tabindex="0">
    <svg class="marker" xmlns="http://www.w3.org/2000/svg" width="15" height="9" viewBox="0 0 15 9" fill="#ffffff">
      <polygon points="0,8 8,0 15,8" fill="#d6d6d6" />
      <polygon points="0,9 8,1 15,9" />
    </svg>
    <div class="seds-flex menu-user-data seds-mt-2 seds-mx-0">
      <div class="seds-ms-0">
        <p tabindex="0" class="seds-m-0 secondary-text seds-font-bold seds-py-2 seds-caption">{{ userData?.name }}</p>
        <p tabindex="0" class="seds-m-0 primary-text user-email seds-pb-2 seds-caption">
          {{ userData?.email | uppercase }}
        </p>
      </div>
    </div>
    <div *ngIf="userData?.menuButtonList">
      <hr class="seds-hr seds-m-0" />
      <ng-container *ngFor="let menus of userData?.menuButtonList; index as i">
        <button
          *ngFor="let menuButton of menus"
          mat-menu-item
          class="menu-header-user-button"
          [attr.aria-label]="menuButton.buttonLabel"
          (click)="clickItemButton(menuButton)"
          disableRipple>
          <mat-icon
            class="seds-flex seds-justify-center seds-items-center menu-icon seds-m-0"
            [ngClass]="menuButton.iconCustomClass || ''">
            {{ menuButton.buttonIconLabel }}
          </mat-icon>
          <p class="seds-m-0 seds-mx-2 seds-caption">{{ menuButton.buttonLabel }}</p>
        </button>
        <hr class="seds-hr seds-m-0" *ngIf="i + 1 < sizeMenu" />
      </ng-container>
    </div>
  </div>
</mat-menu>
